var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadError = function SvgUploadError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.52 3.637A8.75 8.75 0 0 0 8.672 2.9c-1.336.05-3.03.54-4.202 1.711a.75.75 0 0 0 1.06 1.06C6.36 4.846 7.647 4.44 8.728 4.4a7.25 7.25 0 0 1 7.286 5.43.75.75 0 0 0 .726.563H18a4.25 4.25 0 0 1 3.892 5.948c-.291.67-.941 1.326-1.595 1.846a11 11 0 0 1-1.08.752l-.066.04-.016.008-.002.002a.75.75 0 0 0 .734 1.308l-.367-.654.367.653h.002l.002-.002.007-.004.024-.014.086-.05a12.076 12.076 0 0 0 1.244-.866c.703-.56 1.593-1.404 2.035-2.419A5.75 5.75 0 0 0 18 8.893h-.7a8.75 8.75 0 0 0-4.78-5.256m-9.803 4.38a.75.75 0 1 0-1.299-.75 8.75 8.75 0 0 0 1.02 10.172.75.75 0 1 0 1.124-.993 7.25 7.25 0 0 1-.845-8.428m7.141 6.767a.75.75 0 0 1 0 1.06L8.53 17.174a.75.75 0 1 1-1.06-1.06l1.328-1.329a.75.75 0 0 1 1.06 0M12 16.892a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m3 3.643 18 18"
  })));
};
export default SvgUploadError;